import {
  FavouriteStation,
  Station,
  StationsFilter,
  SelectedStation,
  StationPrice,
  StationCategory,
  StationsPricesReport,
  StationsPricesReportFilter,
  StationsPricesReportSettings,
  DownloadStationsPricesReportFilter,
  StationsPricesReportTimeSlot
} from '../types';

import { mappingStationsFilter } from '../utils';

import { locatorServiceAPI } from 'shared/services';

export const stationsAPI = {
  getStation: (code: Station['code'], signal?: AbortSignal) => locatorServiceAPI.get<SelectedStation>(`stations/${code}`, { signal }),
  getStationPrices: (code: Station['code'], signal?: AbortSignal) => locatorServiceAPI.get<StationPrice[]>(`stations/${code}/prices`, { signal }),
  getStations: () => locatorServiceAPI.get<Station[]>('stations'),
  getFilteredStationCodes: (filter: StationsFilter = {}) => locatorServiceAPI.post<Station['code'][]>('stations/search', mappingStationsFilter(filter)),
  getFavouriteStations: () => locatorServiceAPI.get<{ favouriteStations: FavouriteStation[] }>('favourite/stations'),
  addFavouriteStations: (stationCodes: FavouriteStation['stationCode'][]) => locatorServiceAPI.put<{ favouriteStations: FavouriteStation[] }>('favourite/stations', stationCodes),
  deleteFavouriteStations: (stationCodes: FavouriteStation['stationCode'][]) => locatorServiceAPI.delete<{ favouriteStations: FavouriteStation[] }>('favourite/stations', { data: stationCodes }),
  getStationCategories: () => locatorServiceAPI.get<StationCategory[]>('station-categories'),
  // Price report
  getStationsPriceReport: (filter: StationsPricesReportFilter): Promise<{ data: StationsPricesReport }> => locatorServiceAPI.post(`ServicePriceReports/search`, filter),
  createStationsPriceReport: () => locatorServiceAPI.post('ServicePriceReports/generate'),
  downloadStationsPriceReport: (filter: DownloadStationsPricesReportFilter) => locatorServiceAPI.post<Blob>('ServicePriceReports/download', filter,{ responseType: 'blob' }),
  getStationsPriceReportSettings: () => locatorServiceAPI.get<StationsPricesReportSettings>('ServicePriceReports/config'),
  updateStationsPriceReportSettings: (form: StationsPricesReportSettings) => locatorServiceAPI.put<{}>('ServicePriceReports/config', form),
  deleteStationsPriceReportSettings: () => locatorServiceAPI.delete<{}>('ServicePriceReports/config'),
  getStationsPriceReportTimeSlots: () => locatorServiceAPI.get<{ slots: StationsPricesReportTimeSlot[] }>('ServicePriceReports/config/available-time-slots')
};
